/* ======================================================
   AMP CALLBACK CHAIN HELPER (CRITICAL)
====================================================== */
function chainAMPCallback(name, fn) {
  const existing = window[name];
  window[name] = function (...args) {
    if (typeof existing === 'function') {
      existing.apply(this, args);
    }
    fn.apply(this, args);
  };
}

/* ======================================================
   GIFT ADD / REMOVE LOGIC
====================================================== */
(function () {
  const GIFT_VARIANT_ID = 52142128267567;
  const GIFT_THRESHOLD = 7500; // $75 in cents
  let running = false;
  let debounceTimer = null;

  async function getCart() {
    const res = await fetch('/cart.js');
    return res.json();
  }

  function subtotalWithoutGift(cart) {
    return cart.items
      .filter(item => item.variant_id !== GIFT_VARIANT_ID)
      .reduce((sum, item) => sum + item.line_price, 0);
  }

  function findGift(cart) {
    return cart.items.find(item => item.variant_id === GIFT_VARIANT_ID);
  }

  async function addGift() {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: GIFT_VARIANT_ID,
        quantity: 1,
        properties: { _auto_gift: true }
      })
    });
    window.SLIDECART_UPDATE();
  }

  function removeGiftViaAMP() {
    const removeBtn = document.querySelector(
      `[data-variant-id="${GIFT_VARIANT_ID}"] button.remove`
    );
    if (removeBtn) removeBtn.click();
  }

  async function enforceGift() {
    if (running) return;
    running = true;

    try {
      const cart = await getCart();
      const gift = findGift(cart);
      const subtotal = subtotalWithoutGift(cart);

      if (subtotal >= GIFT_THRESHOLD) {
        if (!gift) {
          await addGift();
        }
      } else {
        if (gift) {
          removeGiftViaAMP();
        }
      }
    } catch (e) {
      console.error('[AMP Gift Logic]', e);
    }

    running = false;
  }

  function triggerGiftCheck() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(enforceGift, 120);
  }

  chainAMPCallback('SLIDECART_LOADED', triggerGiftCheck);
  chainAMPCallback('SLIDECART_UPDATED', triggerGiftCheck);
  chainAMPCallback('SLIDECART_ADD_TO_CART', triggerGiftCheck);
  chainAMPCallback('SLIDECART_REMOVED_FROM_CART', triggerGiftCheck);
})();

/* ======================================================
   COMBINED GIFT + FREE SHIPPING THRESHOLD BAR (UI)
====================================================== */
(function () {
  const GIFT_THRESHOLD = 7500;      // $75
  const SHIPPING_THRESHOLD = 10000; // $100
  const GIFT_VARIANT_ID = 52142128267567;

  function formatMoney(cents) {
    return `$${(cents / 100).toFixed(2)}`;
  }

  function subtotalWithoutGift(cart) {
    return cart.items
      .filter(i => i.variant_id !== GIFT_VARIANT_ID)
      .reduce((sum, i) => sum + i.line_price, 0);
  }

  function injectThresholdBar(cart) {
    const container = document.querySelector('#slidecarthq .slidecarthq .rewards');
    if (!container) return;

    let bar = container.querySelector('.combined-threshold-bar');
    const subtotal = subtotalWithoutGift(cart);

    const giftProgress = Math.min(subtotal / GIFT_THRESHOLD, 1);
    const shippingProgress = Math.min(subtotal / SHIPPING_THRESHOLD, 1);
    const totalProgress = Math.min(subtotal / SHIPPING_THRESHOLD, 1) * 100;

    if (!bar) {
      bar = document.createElement('div');
      bar.className = 'combined-threshold-bar';
      bar.innerHTML = `
        <div class="threshold-text"></div>

        <div class="threshold-track">
          <div class="threshold-fill"></div>

          <!-- Gift Icon -->
          <span class="threshold-icon gift-icon">
            🎁
          </span>

          <!-- Shipping Icon -->
          <span class="threshold-icon shipping-icon">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.75 4.5C4.33579 4.5 4 4.83579 4 5.25C4 5.66421 4.33579 6 4.75 6H6.83333H8C8.55228 6 9 6.44772 9 7C9 7.55228 8.55228 8 8 8H6.16667H3.25C2.83579 8 2.5 8.33579 2.5 8.75C2.5 9.16421 2.83579 9.5 3.25 9.5H5.66667H6.25C6.66421 9.5 7 9.83579 7 10.25C7 10.6642 6.66421 11 6.25 11H5.16667H3.75C3.33579 11 3 11.3358 3 11.75C3 12.1642 3.33579 12.5 3.75 12.5H4.20802C4.07422 12.8062 4 13.1444 4 13.5C4 14.8807 5.11929 16 6.5 16C7.88071 16 9 14.8807 9 13.5C9 13.4156 8.99582 13.3322 8.98766 13.25H12.0123C12.0042 13.3322 12 13.4156 12 13.5C12 14.8807 13.1193 16 14.5 16C15.8807 16 17 14.8807 17 13.5C17 13.3627 16.9889 13.2279 16.9676 13.0966C17.5763 12.8226 18 12.2108 18 11.5V10.2808C18 9.47776 17.4535 8.77779 16.6744 8.58303L14.9922 8.16247C14.9055 8.1408 14.837 8.07452 14.8125 7.98862L14.3856 6.49452C14.0483 5.31394 12.9692 4.5 11.7414 4.5H4.75ZM7.5 13.5C7.5 14.0523 7.05228 14.5 6.5 14.5C5.94772 14.5 5.5 14.0523 5.5 13.5C5.5 12.9477 5.94772 12.5 6.5 12.5C7.05228 12.5 7.5 12.9477 7.5 13.5ZM15.5 13.5C15.5 14.0523 15.0523 14.5 14.5 14.5C13.9477 14.5 13.5 14.0523 13.5 13.5C13.5 12.9477 13.9477 12.5 14.5 12.5C15.0523 12.5 15.5 12.9477 15.5 13.5Z" fill="#4A4A4A"></path></svg>
          </span>
        </div>
      `;
      container.prepend(bar);
    }

    const textEl = bar.querySelector('.threshold-text');
    const fillEl = bar.querySelector('.threshold-fill');
    const giftIcon = bar.querySelector('.gift-icon');
    const shipIcon = bar.querySelector('.shipping-icon');

    /* =====================
       TEXT LOGIC
    ====================== */
    if (subtotal < GIFT_THRESHOLD) {
      textEl.innerHTML = `
        ${formatMoney(GIFT_THRESHOLD - subtotal)}
        away from <strong>FREE Gift Bag</strong> worth <strong>$4.99</strong>
      `;
    } else if (subtotal < SHIPPING_THRESHOLD) {
      textEl.innerHTML = `
        <strong>🎁 Gift Bag Unlocked!</strong><br>
        ${formatMoney(SHIPPING_THRESHOLD - subtotal)}
        away from <strong>FREE Shipping</strong> worth <strong>$7.99</strong>
      `;
    } else {
      textEl.innerHTML = `
        <strong>🎁 Gift Bag & 🚚 Free Shipping Applied!</strong>
      `;
    }

    /* =====================
       PROGRESS BAR
    ====================== */
    fillEl.style.width = `${totalProgress}%`;

    /* =====================
       ICON POSITIONS
    ====================== */
    giftIcon.style.left = `${(GIFT_THRESHOLD / SHIPPING_THRESHOLD) * 100}%`;
    shipIcon.style.left = `100%`;

    giftIcon.classList.toggle('active', subtotal >= GIFT_THRESHOLD);
    shipIcon.classList.toggle('active', subtotal >= SHIPPING_THRESHOLD);
  }

  async function updateThresholdBar() {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    injectThresholdBar(cart);
  }

  chainAMPCallback('SLIDECART_LOADED', updateThresholdBar);
  chainAMPCallback('SLIDECART_UPDATED', updateThresholdBar);
  chainAMPCallback('SLIDECART_ADD_TO_CART', updateThresholdBar);
  chainAMPCallback('SLIDECART_REMOVED_FROM_CART', updateThresholdBar);
})();
